/**
 * Enum for all supported third-party systems
 */
var SystemType;
(function (SystemType) {
    SystemType["LIGHTSPEED"] = "lightspeed";
    SystemType["SHOPIFY"] = "shopify";
    SystemType["DEALER_SPIKE"] = "dealer_spike";
    SystemType["PIXEL_MOTION"] = "pixel_motion";
    SystemType["DEALER_ACCELERATE"] = "dealer_accelerate";
    SystemType["MOTION"] = "motion";
    SystemType["PCRS"] = "pcrs";
    SystemType["PEN"] = "pen";
    SystemType["EKHO"] = "ekho";
    SystemType["GENERIC_WEBSITE"] = "generic_website";
    SystemType["GENERIC_DMS"] = "generic_dms";
    SystemType["GENERIC_FAI"] = "generic_fai";
    SystemType["DEV"] = "dev";
})(SystemType || (SystemType = {}));
var SystemCategory;
(function (SystemCategory) {
    SystemCategory["WEBSITE"] = "website";
    SystemCategory["DMS"] = "dms";
    SystemCategory["FAI"] = "fai";
    SystemCategory["EKHO"] = "ekho";
    SystemCategory["OTHER"] = "other";
})(SystemCategory || (SystemCategory = {}));
/**
 * Map from SystemType to SystemCategory
 * This allows us to derive the category from the system type without storing it
 */
const SYSTEM_TYPE_TO_CATEGORY_MAP = {
    [SystemType.LIGHTSPEED]: SystemCategory.DMS,
    [SystemType.SHOPIFY]: SystemCategory.WEBSITE,
    [SystemType.DEALER_SPIKE]: SystemCategory.WEBSITE,
    [SystemType.PIXEL_MOTION]: SystemCategory.WEBSITE,
    [SystemType.DEALER_ACCELERATE]: SystemCategory.WEBSITE,
    [SystemType.MOTION]: SystemCategory.WEBSITE,
    [SystemType.PCRS]: SystemCategory.FAI,
    [SystemType.PEN]: SystemCategory.FAI,
    [SystemType.EKHO]: SystemCategory.EKHO,
    [SystemType.GENERIC_WEBSITE]: SystemCategory.WEBSITE,
    [SystemType.GENERIC_DMS]: SystemCategory.DMS,
    [SystemType.GENERIC_FAI]: SystemCategory.FAI,
    [SystemType.DEV]: SystemCategory.OTHER,
};
/**
 * Gets the SystemCategory for a given SystemType
 * @param systemType - The system type
 * @returns The corresponding system category, or OTHER if not found
 */
function getSystemCategory(systemType) {
    return SYSTEM_TYPE_TO_CATEGORY_MAP[systemType] || SystemCategory.OTHER;
}
const CoverageProviderType = {
    MCGRAW: 'mcgraw',
    RIDERS_ADVANTAGE: 'ridersAdvantage',
};
const COVERAGE_PROVIDER_TYPES = [
    CoverageProviderType.MCGRAW,
    CoverageProviderType.RIDERS_ADVANTAGE,
];

export { COVERAGE_PROVIDER_TYPES, CoverageProviderType, SYSTEM_TYPE_TO_CATEGORY_MAP, SystemCategory, SystemType, getSystemCategory };
//# sourceMappingURL=SystemType.js.map
